import type { AlertState, AlertVariant } from "./order-alert.types";
import { SESSION_STORAGE_KEY, ALERT_TIMING } from "./order-alert.config";

export const getAlertState = (): AlertState => {
  const launchDateStr = import.meta.env.VITE_ORDER_ALERT_LAUNCH_DATE;

  if (!launchDateStr) {
    return { shouldShow: false, canClose: false };
  }

  const launchDate = new Date(launchDateStr);
  const now = new Date();

  const daysSinceLaunch = Math.floor(
    (now.getTime() - launchDate.getTime()) / (1000 * 60 * 60 * 24),
  );

  if (daysSinceLaunch < ALERT_TIMING.NOT_LAUNCHED) {
    return { shouldShow: false, canClose: false };
  }

  if (daysSinceLaunch > ALERT_TIMING.KNOWLEDGE_PERIOD_DAYS) {
    return { shouldShow: false, canClose: false };
  }

  if (daysSinceLaunch <= ALERT_TIMING.EDUCATIONAL_PERIOD_DAYS) {
    return { shouldShow: true, canClose: false };
  }

  const isDismissedInSession = sessionStorage.getItem(SESSION_STORAGE_KEY);
  if (isDismissedInSession === "true") {
    return { shouldShow: false, canClose: true };
  }

  return { shouldShow: true, canClose: true };
};

export const isValidVariant = (variant: string): variant is AlertVariant => {
  return ["create", "edit", "list", "vision"].includes(variant);
};

export const openUrlSafely = (url: string): void => {
  const newWindow = window.open(url, "_blank");

  if (
    !newWindow ||
    newWindow.closed ||
    typeof newWindow.closed === "undefined"
  ) {
    // Popup bloqueado, tenta navegação normal
    window.location.href = url;
  }
};
